import React, { Suspense } from "react";
import ProtectedRoute from "ProtectedRoute";
import ShieldOutlinedIcon from "@mui/icons-material/ShieldOutlined";

/**
 * Plan L Phase L5 — Safety & Compliance lane.
 *
 * Frontend-only aggregator that surfaces every safety-relevant domain
 * (LOTO emergency lighting, AFMS SPCC, AFMS training, cross-module
 * inspections + findings) under one navigable lane. Owns no backend.
 *
 * Posture: **platform-core** — no `laneKey` gate. The page renders
 * gracefully empty when underlying data isn't there. Module-specific
 * pages it links to ARE gated; this is just the aggregator lens.
 *
 * Visible to every authenticated org user. Same posture as Inspections
 * (Plan L3) for the same reason — it's a cross-cutting lens.
 */
const SafetyOverview = React.lazy(() => import("safety/pages/Overview"));
const SafetyInspectionCalendar = React.lazy(() => import("safety/pages/InspectionCalendar"));

const safetyRoutes = [
  {
    type: "collapse",
    name: "Safety & Compliance",
    key: "safety",
    icon: <ShieldOutlinedIcon />,
    collapse: [
      {
        name: "Overview",
        key: "safety-overview",
        route: "/safety",
        component: (
          <ProtectedRoute>
            <Suspense fallback={null}>
              <SafetyOverview />
            </Suspense>
          </ProtectedRoute>
        ),
      },
      {
        name: "Inspection Calendar",
        key: "safety-calendar",
        route: "/safety/calendar",
        component: (
          <ProtectedRoute>
            <Suspense fallback={null}>
              <SafetyInspectionCalendar />
            </Suspense>
          </ProtectedRoute>
        ),
      },
    ],
  },
];

export default safetyRoutes;
